var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconExpandAndView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.75 11.508-1.59 1.59-2.38-2.378-1.06 1.06 2.379 2.38-1.591 1.59h4.242v-4.242ZM2.25 6.492l1.59-1.59L6.22 7.28l1.06-1.06-2.379-2.38 1.591-1.59H2.25v4.242Zm13.5-4.242h-4.242l1.59 1.59-2.378 2.38 1.06 1.06 2.38-2.379 1.59 1.591V2.25Zm-13.5 13.5h4.242l-1.59-1.59 2.378-2.38-1.06-1.06-2.38 2.379-1.59-1.591v4.242Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpandAndView);
export default __webpack_public_path__ + "static/media/icon_expand_and_view.3b69892420bbf4229bde94cf1f09fad0.svg";
export { ForwardRef as ReactComponent };